import React from "react";

export default function DatenschutzModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal show" onClick={onClose}>
      <div
        className="sheet datenschutz-sheet"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sheet-head">
          <h2>Datenschutzerklärung</h2>
          <button className="close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="datenschutz-body">
          <h3 style={{ color: "var(--green)", marginTop: "0" }}>
            1. Datenschutz auf einen Blick
          </h3>
          <p>
            <strong>Allgemeine Hinweise</strong>
            <br />
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was
            mit Ihren personenbezogenen Daten passiert, wenn Sie unsere digitale
            Speisekarte besuchen. Personenbezogene Daten sind alle Daten, mit
            denen Sie persönlich identifiziert werden können.
          </p>

          <h3 style={{ color: "var(--green)", marginTop: "20px" }}>
            2. Verantwortliche Stelle
          </h3>
          <p>
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser
            Website ist:
          </p>
          <p
            style={{
              background: "var(--green-soft)",
              padding: "12px",
              borderRadius: "8px",
            }}
          >
            <strong>Beyzade Baklava & Café</strong>
            <br />
            [Sokak ve Bina No]
            <br />
            [Posta Kodu ve Şehir]
            <br />
            Telefon: [Telefon Numarası]
            <br />
            E-Mail: [E-posta Adresi]
          </p>

          <h3 style={{ color: "var(--green)", marginTop: "20px" }}>
            3. Datenerfassung auf unserer Website
          </h3>
          <p>
            <strong>Bereitstellung der Website (Server-Log-Files)</strong>
            <br />
            Der Provider der Seiten erhebt und speichert automatisch
            Informationen in so genannten Server-Log-Dateien, die Ihr Browser
            automatisch an uns übermittelt.
          </p>

          <h3 style={{ color: "var(--green)", marginTop: "20px" }}>
            4. Ihre Rechte
          </h3>
          <p>
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
            Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
            erhalten.
          </p>

          <div style={{ marginTop: "30px", textAlign: "center" }}>
            <button
              className="primary-btn"
              onClick={onClose}
              style={{ width: "100%" }}
            >
              Schließen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
